<div class="load-trade-versions">
  <div
    class="load-trade-versions__setup"
    *ngIf="showMenu; else tradesManagerTable"
  >
    <input
      type="text"
      class="clr-input"
      placeholder="Trade ID"
      autocomplete="off"
      [(ngModel)]="tradeId"
    />

    <button
      (click)="loadTradeRecords()"
      type="button"
      class="ui-button ui-button--load-trades"
      [disabled]="!tradeId"
      [ngClass]="{ primary: tradeId?.length }"
    >
      <ng-container *ngIf="state !== 'LOADING'; else loadTrades">
        Load trade versions
      </ng-container>
      <ng-template #loadTrades>
        <span class="spinner spinner-sm spinner-inverse"> </span>
      </ng-template>
    </button>

    <button type="button" class="ui-button ui-button--back" (click)="goBack()">
      Back
    </button>
  </div>

  <ng-template #tradesManagerTable>
    <div class="load-trade-versions__table-container">
      <ag-grid-angular
        [rowData]="rowData"
        class="
          ag-theme-balham-dark
          load-trade-versions__table-container__ag-grid
        "
        [columnDefs]="columnDefs"
        rowSelection="multiple"
        [groupSelectsChildren]="true"
        [suppressRowClickSelection]="true"
        [sideBar]="sideBarDef"
        (selectionChanged)="onSelectionChanged()"
        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>

      <div class="load-trade-versions__table-container__footer">
        <button
          type="button"
          class="ui-button ui-button__footer ui-button--loaded"
          (click)="loadTrades()"
          [disabled]="!selectedLoadedTrades?.length"
        >
          {{
            selectedLoadedTrades?.length || 0
              | i18nPlural
                : {
                    '=0': 'No trades selected',
                    '=1': 'Load selected trade',
                    other: 'Load selected trades'
                  }
          }}
        </button>

        <button
          type="button"
          class="ui-button ui-button__footer ui-button--back"
          (click)="goBack()"
        >
          Back
        </button>
      </div>
    </div>
  </ng-template>
</div>
